import type { SVGProps } from 'react';
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M17.8925 5.3025C17.5025 4.9125 16.8725 4.9125 16.4825 5.3025L11.5925 10.1825L6.7025 5.2925C6.3125 4.9025 5.6825 4.9025 5.2925 5.2925C4.9025 5.6825 4.9025 6.3125 5.2925 6.7025L10.1825 11.5925L5.2925 16.4825C4.9025 16.8725 4.9025 17.5025 5.2925 17.8925C5.6825 18.2825 6.3125 18.2825 6.7025 17.8925L11.5925 13.0025L16.4825 17.8925C16.8725 18.2825 17.5025 18.2825 17.8925 17.8925C18.2825 17.5025 18.2825 16.8725 17.8925 16.4825L13.0025 11.5925L17.8925 6.7025C18.2725 6.3225 18.2725 5.6825 17.8925 5.3025Z" />
  </svg>
);
export default SvgClose;
